(function () {
  'use strict';

  angular
    .module('dashboard.project.overview')
    .factory('DashboardProjectOverview', DashboardProjectOverview);

  DashboardProjectOverview.$inject = ['$resource'];

  function DashboardProjectOverview($resource) {
    return $resource(
      '/api/',
      {},
      {
        getProjectOverview: {
          method: 'GET',
          url: '/api/dashboard/project_overview/:from/:to',
        },
      },
    );
  }
})();
